import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    icon: "ri-movie-2-line",
    label: "电影大全",
    desc: "热门与经典佳片",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    label: "电视剧列表",
    desc: "剧集与连载佳作",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    label: "影视资讯",
    desc: "行业与剧集动态",
  },
  {
    to: "/search",
    icon: "ri-search-eye-line",
    label: "搜索发现",
    desc: "按关键词快速找片",
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-3 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50 transition-colors"
        >
          <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
            <i className={entry.icon}></i>
          </span>
          <span className="min-w-0">
            <span className="block text-sm md:text-base font-medium text-foreground-950">
              {entry.label}
            </span>
            <span className="block text-xs text-foreground-500 mt-1 line-clamp-1">
              {entry.desc}
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}